import { Component } from '@angular/core';

@Component({
  selector: 'em-equipment',
  templateUrl: './equipment.component.html',
  standalone: false,
})
export class EquipmentComponent {}
